export default __webpack_public_path__ + "static/media/DragonsQuill-Logo.7b88fe8e.svg";